// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"245":"1bfdcd1b","389":"4bd99f34","583":"2daa20f9","753":"f01c3c27","787":"c096999d","810":"48dbdec4","955":"08dd0edd"}[chunkId] + ".chunk.js";
};